import { render, staticRenderFns } from "./LayoutContentRendererOpenAi.vue?vue&type=template&id=3bffeb65&scoped=true&"
import script from "./LayoutContentRendererOpenAi.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererOpenAi.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentRendererOpenAi.vue?vue&type=style&index=0&id=3bffeb65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bffeb65",
  null
  
)

export default component.exports